import { render, staticRenderFns } from "./reg-custom.vue?vue&type=template&id=c4a33d2c&scoped=true&"
import script from "./reg-custom.vue?vue&type=script&lang=js&"
export * from "./reg-custom.vue?vue&type=script&lang=js&"
import style0 from "./reg-custom.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./reg-custom.vue?vue&type=style&index=1&id=c4a33d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a33d2c",
  null
  
)

export default component.exports